/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect } from 'react-redux';
import { ReviewAppState } from '../redux/reducers';

const mapStateToProps = (state: ReviewAppState) => ({
  page: state.page
});

type Props = {
  page: number;
  children: any;
};

class ScrollToTop extends React.Component<any> {
  componentDidUpdate(prevProps: Props) {
    const { page } = this.props;
    if (prevProps.page !== page) {
      document.getElementById('root').scrollIntoView({ behavior: 'smooth' });
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

export default connect(mapStateToProps)(ScrollToTop);
